"use client"

import HotelGoodPriceItemSkeleton from "./HotelGoodPriceItem.skeleton"

const HotelGoodPricesMobileSkeleton = () => {
  return (
    <div className="hotels__goodprices--scroll">
      <div className="hotels__goodprices--scroll-track">
        {Array(4).fill(null).map((_, idx) => (
          <div className="hotels__goodprices--scroll-item hotels__goodprices--item skeleton" key={idx}>
            <HotelGoodPriceItemSkeleton />
          </div>
        ))}
      </div>
    </div>
  )
}

export default HotelGoodPricesMobileSkeleton
